import * as React from "react";
import MUIButton from "@mui/material/Button";
import { useTheme, useMediaQuery } from "@mui/material";
import SC from "./style.js";
import TooltipText from "components/TooltipText";

const Button = (props) => {
  const {
    caption,
    leftIcon,
    rightIcon,
    tooltip,
    visible = true,
    subcaption,
    sx,
    fontSize,
    fontWeight,
    color,
    maxLength = 25,
    ...rest
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!visible) return null;

  return (
    <MUIButton
      {...rest}
      sx={{
        minHeight: isMobile ? 36 : 32,
        minWidth: isMobile ? "100%" : "auto",
        px: isMobile ? 1.5 : 2,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        ...SC.MUIButtonrt,
        ...sx,
      }}
    >
      {leftIcon && (
        <SC.LeftButton isMobile={isMobile}>{leftIcon}</SC.LeftButton>
      )}

      <SC.forprofile>
        <SC.Container
          fontSize={fontSize}
          fontWeight={fontWeight}
          color={color}
          isMobile={isMobile}
        >
          {/* <TooltipText title={caption} maxLength={isMobile ? 18 : maxLength} /> */}
          {caption}
        </SC.Container>

        {subcaption && (
          <SC.Subcaption isMobile={isMobile}>{subcaption}</SC.Subcaption>
        )}
      </SC.forprofile>

      {rightIcon && (
        <SC.RightButton isMobile={isMobile}>{rightIcon}</SC.RightButton>
      )}
    </MUIButton>
  );
};

export default Button;
